import qs from "qs";
import { isBrowser } from "../../utils";

export const PAGE_SIZE = 10;

export function getQuery(req) {
  if (req) {
    return req.query;
  }

  if (isBrowser) {
    return qs.parse(window.location.search.slice(1));
  }
  return {};
}

export function getListParams(req) {
  const { keyword, category, page = 1 } = getQuery(req);

  const q = {
    category: Number(category) || undefined,
    _limit: PAGE_SIZE,
    _start: Math.max(page - 1, 0) * PAGE_SIZE,
    _sort: "publishedAt:DESC,published_at:DESC",
  };

  if (keyword) {
    q._where = {
      _or: [
        {
          title_contains: keyword,
        },
        { content_contains: keyword },
      ],
    };
  }

  return q;
}
